<script>
    import TextHighlight from "vue-text-highlight";

    export default {
        props: {
            name: {
                type: String,
                required: false,
                default: ''
            },
            highlight: {
                type: String,
                required: false,
                default: ''
            },
            search: {
                type: String,
                required: false,
                default: ''
            }
        },

        methods: {
            createHighlightAll: function (createElement) {
                return createElement('mark', this.$slots.default);
            },

            createDivNode: function (createElement) {
                return createElement('div', this.$slots.default);
            },

            createHighlightedNodes: function (createElement, slots) {
                let nodes = [];

                for (let node of slots) {
                    let nodeChildren = [];

                    if (node.children !== undefined) {
                        nodeChildren = this.createHighlightedNodes(createElement, node.children);
                    }

                    let element = null;

                    if (node.tag === undefined && node.text !== undefined) {
                        element = createElement(TextHighlight, {
                            props: {
                                queries: this.searchArray,
                                highlightStyle: "background-color: #fffd03"
                            }
                        }, [node.text]);
                    } else {
                        element = createElement(node.tag, nodeChildren);
                    }
                    if (node.data !== undefined && !element.tag.startsWith('vue-component')){
                        element.data = node.data
                    }
                    nodes.push(element);
                }

                return nodes;
            }
        },

        render: function (createElement) {
            let slots = [];
            if(this.show) {
                if (this.highlightAll) {
                    slots.push(this.createHighlightAll(createElement));
                } else if (this.filtered && !this.highlightAll) {
                    if (this.$slots.default !== undefined && this.highlight !=="off") {
                        slots = this.createHighlightedNodes(createElement, this.$slots.default);
                    }else{
                        slots = this.$slots.default;
                    }
                } else if (!this.filtered) {
                    slots = this.$slots.default;
                }

                return createElement('td', {
                    class: "table-cell"
                }, slots);
            }
        },

        computed: {
            show: function () {
                return (this.hidden.indexOf(this.name) < 0);
            },

            hidden: function () {
                return this.$parent.hidden;
            },

            filtered: function () {
                return !!(this.$parent.$parent.filter[this.name]);
            },

            highlightAll: function () {
                return (this.highlight === '*') && (this.filtered);
            },

            filterValue: function () {
                return this.$parent.$parent.filter[this.name];
            },

            searchArray: function () {
                if (this.highlight.length > 0 && !this.highlightAll) {
                    return this.highlight;
                }

                return this.filterValue.split(" ");
            }
        }
    }
</script>

<style>
    .highlight-all {
        background: rgba(249, 255, 0, 0.5);
    }
</style>
